// extracted by mini-css-extract-plugin
module.exports = {"items":"EntityAttachment_items__1D3e4"};